<template>
  <div class="flex h-[40px] w-full cursor-pointer items-center justify-center border-t border-t-gray2 bg-black4 outline-0" @click="onClick">
    <span
      class="flex items-center gap-2 text-xs tracking-widest text-gray5 after:relative after:top-[3px] after:block after:h-[10px] after:w-[10px] after:-rotate-45 after:border-r after:border-t after:border-white"
    >
      <slot />
    </span>
  </div>
</template>

<script setup lang="ts">
const onClick = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};
</script>
